import { Action, Role, VoiceChatMessage } from "@/lib/messaging";

import { useCallback } from "react";
import { useLearnLanguage } from "@/context/learn-language-context";
import { usePocketBase } from "@/context/pocketbase-context";

const useMessaging = () => {
  const { token, session } = usePocketBase();
  const { languageProficiency } = useLearnLanguage();

  // Function to build voicechat message
  const buildMessage = useCallback(
    (
      role: Role,
      action: Action,
      modeStr: string,
      userLanguage?: string,
      userLanguageCode?: string,
    ) => {
      return {
        role: role,
        action: action,
        modeStr: modeStr,
        session,
        token,
        userLanguage: userLanguage,
        userLanguageCode: userLanguageCode,
        language: languageProficiency.language.name,
        languageCode: languageProficiency.language.key,
        proficiencyLevel: languageProficiency.proficiency,
      } as VoiceChatMessage;
    },
    [token, languageProficiency, session],
  );

  return { buildMessage };
};

export default useMessaging;
